import React from 'react';
import { useAuth, useT } from '@repo/common';

const HEADER_CONFIG = {
  A: {
    title: 'Job Board (admin)',
    titleKr: '채용 공고 (관리자)',
    titleClass: 'typo-h5',
  },
  E: {
    title: 'Job Board',
    titleKr: '채용 공고',
    titleClass: 'typo-h5',
  },
  DEFAULT: {
    title: 'Job Board',
    titleKr: '채용 공고',
    titleClass: 'typo-h5',
    subtitle: 'Career opportunities in Korea for global talent',
    subtitleKr: '글로벌 인재를 위한 한국 취업 기회',
    subtitleClass: 'typo-b16Strong',
    mobileTitle: 'Find career opportunities in Korea for global talent',
    mobileTitleKr: '글로벌 인재를 위한 한국 취업 기회를 찾아보세요',
  },
};

const JobHeader = ({ role }) => {
  const t = useT();
  const { isLoggedIn } = useAuth();
  const normalizedRole = String(role ?? '').toUpperCase();
  const isAdmin = ['A', 'ROLE_A', 'ADMIN', 'ROLE_ADMIN'].includes(
    normalizedRole,
  );
  const isEmployer = ['E', 'ROLE_E', 'EMPLOYER', 'ROLE_EMPLOYER'].includes(
    normalizedRole,
  );
  const isManager = isAdmin || isEmployer;
  const config = isAdmin
    ? HEADER_CONFIG.A
    : isEmployer
      ? HEADER_CONFIG.E
      : HEADER_CONFIG.DEFAULT;

  const showMobileHeadline = Boolean(config.mobileTitle) && !isLoggedIn;

  return (
    <div
      className={`flex flex-col items-start tabletV:items-center pt-0 px-0 relative shrink-0 w-full ${
        isManager
          ? 'pb-4'
          : `${showMobileHeadline ? 'pb-4' : 'pb-0'} tabletV:pb-[50px]`
      }`}
    >
      <div className='flex flex-col text-text-primary w-full gap-0.5'>
        {showMobileHeadline && (
          <p className='text-left typo-title1 tabletV:hidden'>
            {t(config.mobileTitle, config.mobileTitleKr)}
          </p>
        )}
        <p
          className={`text-center ${config.titleClass} ${
            config.mobileTitle ? 'hidden tabletV:block' : ''
          }`}
        >
          {t(config.title, config.titleKr)}
        </p>
        {config.subtitle && (
          <p
            className={`text-center ${config.subtitleClass} hidden tabletV:block`}
          >
            {t(config.subtitle, config.subtitleKr)}
          </p>
        )}
      </div>
    </div>
  );
};

export default JobHeader;
